/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AnalyzeProgressDto {
  phase: AnalyzeProgressDtoPhaseEnum;
  total: number;
  done: number;
  current: string | null;
}

export interface DatabaseFieldDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  attemptId?: string;
  type: DatabaseFieldDtoTypeEnum;
  subType?: DatabaseFieldDtoSubTypeEnum;
  nullable?: boolean;
  default?: string;
  primary?: boolean;
  isArray?: boolean;
  isEnum?: boolean;
  enum?: string[];
  indexed?: boolean;
  unique?: boolean;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  databaseCollectionId: string;
}

export interface DatabaseIndexDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** The name of the index */
  name: string;
  /** The fields included in the index */
  fields: string[];
  unique: boolean;
  attemptId?: string;
  databaseCollectionId: string;
}

export interface DatabaseRelationDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  type: string;
  fields: string[];
  attemptId?: string;
  databaseCollectionId: string;
  targetCollectionId: string;
  databaseFieldId: string;
  targetFieldId: string;
}

export interface DatabaseCollectionDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  fields: DatabaseFieldDto[];
  indexes: DatabaseIndexDto[];
  relations: DatabaseRelationDto[];
  targetRelations: DatabaseRelationDto[];
  collectionSamplingResultId?: string;
  attemptId?: string;
  datasourceId: string;
}

export interface FormFieldDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  label: string;
  description: string;
  hint: string;
  isRequired: boolean;
  isUnique: boolean;
  isArray: boolean;
  isEnum: boolean;
  enum: string[];
  collection: string;
  field: string;
  formId: string;
  type: string;
  subType: string;
  order: number;
}

export interface FormDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  title: string;
  description: string;
  layout: string;
  fields: FormFieldDto[];
  attemptId: string;
  /** The id of the datasource */
  datasourceId: string;
}

export interface DataTableFieldDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  type: string;
  subType: string;
  order: number;
  datatableId: string;
  sortable: boolean;
  filterable: boolean;
  attemptId: string;
  filterForm: FormDto;
}

export interface DataTableDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  fields: DataTableFieldDto[];
  dashboardId: string;
  attemptId: string;
  collection: string;
  /** The id of the datasource */
  datasourceId: string;
}

export interface ChartDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  type: string;
  title: string;
  description: string;
  collections: string[];
  dashboardId: string;
  attemptId: string;
  /** Column the series groups by. */
  groupBy?: string;
  /** Date bucket for a time series. */
  bucket?: string;
}

export interface DashboardDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  order: number;
  dataTables: DataTableDto[];
  charts: ChartDto[];
  forms: FormDto[];
  attemptId: string;
  panelId: string;
  /** The id of the datasource */
  datasourceId: string;
}

export interface PanelDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  dashboards: DashboardDto[];
  attemptId: string;
}

export interface UiGenerationAttemptDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  status: UiGenerationAttemptDtoStatusEnum;
  error?: object;
  prompt: string;
  published: boolean;
  panels: PanelDto[];
}

export interface AnalyzeAttemptDto {
  id: string;
  status: AnalyzeAttemptDtoStatusEnum;
  /** Live progress reported by the analyzer while RUNNING. Shape: { phase, total, done, current }. */
  progress?: AnalyzeProgressDto;
  errorMessage?: string | null;
  published: boolean;
  databaseCollections?: DatabaseCollectionDto[];
  databaseIndexes?: DatabaseIndexDto[];
  databaseRelations?: DatabaseRelationDto[];
  uiGenerationAttempts?: UiGenerationAttemptDto[];
}

export interface DatasourceDto {
  /** The id of the database connection */
  id?: string;
  /** The name of the database connection */
  name: string;
  /** The type of the database connection */
  type: DatasourceDtoTypeEnum;
  /** The connection string of the database connection */
  connectionString: string;
  /** Shared guest demo datasource */
  isDemo?: boolean;
  /** Writes are forbidden when true */
  readOnly?: boolean;
  /** The latest analyze attempt */
  analyzeAttempts?: AnalyzeAttemptDto[];
  /** The id of the project */
  projectId?: string;
  authMode?: string;
  sheetsTooLarge?: boolean;
  // googleConnectionId is accepted on CREATE only; GET responses never include
  // it (onlydash-api toDatasourceDto strips it). Do not match on it client-side.
  /** The caller's role on the project, when they are not the owner */
  viewerRole?: string;
}

export interface PaginationInfoDto {
  /**
   * Current page number
   * @example 1
   */
  page: number;
  /**
   * Number of items per page
   * @example 10
   */
  limit: number;
  /**
   * Total number of pages
   * @example 5
   */
  totalPages: number;
}

export interface DataListDto {
  /**
   * Total number of items
   * @example 50
   */
  total: number;
  /** Pagination information */
  pagination: PaginationInfoDto;
  /** Array of items */
  items: any[][];
}

export interface AggregateSeriesPointDto {
  /** Category label, or bucket start for dates */
  label: string;
  /** SUM of the measure, or COUNT(*) */
  value: number;
}

export interface AggregateSeriesDto {
  points: AggregateSeriesPointDto[];
  /** Column that was grouped on */
  groupBy: string;
  /** Column that was summed. Absent means the values are counts. */
  measure?: string;
  /** Rows the aggregate covers. This is the whole collection, not a page. */
  rows: number;
  /** True when the tail was folded into an "Other" point. */
  truncated: boolean;
  /** True when the series was computed against filterGroups. Absent on older APIs. */
  filtered?: boolean;
}

export type Object = object;

export interface AuthGuestDto {
  /**
   * Guest ID
   * @format uuid
   */
  id?: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt?: string;
  name: string;
  /**
   * Last update timestamp
   * @format date-time
   */
  updatedAt?: string;
  /**
   * Associated user ID
   * @format uuid
   */
  userId?: string;
}

export interface AuthTokenDto {
  /** JWT token */
  token: string;
}

export interface RegisterDto {
  /** User email address */
  email: string;
  /**
   * User password
   * @minLength 8
   */
  password: string;
  /** User first name */
  firstName?: string;
  /** User last name */
  lastName?: string;
}

export interface LoginDto {
  /** User email address */
  email: string;
  /** User password */
  password: string;
}

export interface RequestPasswordResetDto {
  /** User email address */
  email: string;
}

export interface AuthCodeDto {
  /**
   * Code ID
   * @format uuid
   */
  id: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   */
  updatedAt: string;
  /**
   * Expiration timestamp
   * @format date-time
   */
  expiresAt: string;
  /** Code type */
  type: AuthCodeDtoTypeEnum;
  /** Verification/reset code */
  code?: string;
  /**
   * Associated user ID
   * @format uuid
   */
  userId: string;
}

export interface ResetPasswordDto {
  /** Password reset code */
  code: string;
  /**
   * New password
   * @minLength 8
   */
  newPassword: string;
}

export interface AuthUserDto {
  /**
   * User ID
   * @format uuid
   */
  id: string;
  /**
   * Creation timestamp
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update timestamp
   * @format date-time
   */
  updatedAt: string;
  /** User email address */
  email: string;
  /** User first name */
  firstName?: string;
  /** User last name */
  lastName?: string;
  /** Email verification status */
  isVerified: boolean;
  /**
   * Last login timestamp
   * @format date-time
   */
  lastLoginAt?: string;
}

export enum AnalyzeProgressDtoPhaseEnum {
  Starting = "starting",
  Schema = "schema",
  Persisting = "persisting",
  Sampling = "sampling",
  Done = "done",
}

export enum DatabaseFieldDtoTypeEnum {
  STRING = "STRING",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  OBJECT = "OBJECT",
}

export enum DatabaseFieldDtoSubTypeEnum {
  TEXT = "TEXT",
  JSON = "JSON",
  HTML = "HTML",
  MARKDOWN = "MARKDOWN",
  BASE64 = "BASE64",
  EMAIL = "EMAIL",
  URL = "URL",
  UUID = "UUID",
  IP_ADDRESS = "IP_ADDRESS",
  MAC_ADDRESS = "MAC_ADDRESS",
  HOSTNAME = "HOSTNAME",
  PHONE_NUMBER = "PHONE_NUMBER",
  PHONE_NUMBER_WITH_CODE = "PHONE_NUMBER_WITH_CODE",
  PHONE_NUMBER_WITH_COUNTRY_CODE = "PHONE_NUMBER_WITH_COUNTRY_CODE",
  COUNTRY_CODE = "COUNTRY_CODE",
  COUNTRY_NAME = "COUNTRY_NAME",
  CITY = "CITY",
  STATE = "STATE",
  ZIP_CODE = "ZIP_CODE",
  ADDRESS = "ADDRESS",
  FILE_PATH = "FILE_PATH",
  IMAGE_URL = "IMAGE_URL",
  VIDEO_URL = "VIDEO_URL",
  AUDIO_URL = "AUDIO_URL",
  PASSWORD = "PASSWORD",
  COLOR = "COLOR",
  TIME = "TIME",
  INTEGER = "INTEGER",
  FLOAT = "FLOAT",
  DECIMAL = "DECIMAL",
  PERCENTAGE = "PERCENTAGE",
  CURRENCY = "CURRENCY",
  BOOLEAN = "BOOLEAN",
  TIMESTAMP = "TIMESTAMP",
  DATE = "DATE",
  DATETIME_WITH_TIMEZONE = "DATETIME_WITH_TIMEZONE",
  DATETIME_WITHOUT_TIMEZONE = "DATETIME_WITHOUT_TIMEZONE",
}

export enum UiGenerationAttemptDtoStatusEnum {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum AnalyzeAttemptDtoStatusEnum {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

/** The type of the database connection */
export enum DatasourceDtoTypeEnum {
  POSTGRESQL = "POSTGRESQL",
  MONGODB = "MONGODB",
  GOOGLE_SHEETS = "GOOGLE_SHEETS",
  MYSQL = "MYSQL",
}

/** Code type */
export enum AuthCodeDtoTypeEnum {
  VERIFICATION = "VERIFICATION",
  PASSWORD_RESET = "PASSWORD_RESET",
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title OnlyDash API
 * @version 1.0
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  datasources = {
    /**
     * No description
     *
     * @tags Datasources
     * @name GetDatasources
     * @summary Get all saved datasource connections
     * @request GET:/datasources
     * @response `200` `(DatasourceDto)[]` List of saved datasource connections
     */
    getDatasources: (params: RequestParams = {}) =>
      this.request<DatasourceDto[], any>({
        path: `/datasources`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name CreateDatasource
     * @summary Create a new datasource connection
     * @request POST:/datasources
     * @response `201` `DatasourceDto` The created datasource connection
     */
    createDatasource: (data: DatasourceDto, params: RequestParams = {}) =>
      this.request<DatasourceDto, any>({
        path: `/datasources`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name GetDatasource
     * @summary Get a specific saved datasource connection
     * @request GET:/datasources/{datasourceId}
     * @response `200` `DatasourceDto` The saved datasource connection
     */
    getDatasource: (datasourceId: string, params: RequestParams = {}) =>
      this.request<DatasourceDto, any>({
        path: `/datasources/${datasourceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name UpdateDatasource
     * @summary Update a datasource connection
     * @request PUT:/datasources/{datasourceId}
     * @response `200` `DatasourceDto` The updated datasource connection
     */
    updateDatasource: (
      datasourceId: string,
      data: DatasourceDto,
      params: RequestParams = {},
    ) =>
      this.request<DatasourceDto, any>({
        path: `/datasources/${datasourceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name PartialUpdateDatasource
     * @summary Partially update a datasource connection
     * @request PATCH:/datasources/{datasourceId}
     * @response `200` `DatasourceDto` The partially updated datasource connection
     */
    partialUpdateDatasource: (
      datasourceId: string,
      data: DatasourceDto,
      params: RequestParams = {},
    ) =>
      this.request<DatasourceDto, any>({
        path: `/datasources/${datasourceId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name DeleteDatasource
     * @summary Delete a datasource connection
     * @request DELETE:/datasources/{datasourceId}
     * @response `200` `void` The deleted datasource connection
     */
    deleteDatasource: (datasourceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/datasources/${datasourceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name GetDatasourceCollections
     * @summary Get collections for a specific datasource
     * @request GET:/datasources/{datasourceId}/collections
     * @response `200` `(string)[]` List of collections in the datasource
     */
    getDatasourceCollections: (
      datasourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<string[], any>({
        path: `/datasources/${datasourceId}/collections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Datasources
     * @name TestDatasource
     * @summary Test a datasource connection
     * @request POST:/datasources/test
     * @response `201` `DatasourceDto` The created datasource connection
     */
    testDatasource: (data: DatasourceDto, params: RequestParams = {}) =>
      this.request<DatasourceDto, any>({
        path: `/datasources/test`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  analysis = {
    /**
     * No description
     *
     * @tags Analysis
     * @name CreateAnalyzeAttempt
     * @summary Create an analysis attempt
     * @request POST:/analysis/{datasourceId}/attempts
     * @response `201` `AnalyzeAttemptDto` The analysis attempt
     */
    createAnalyzeAttempt: (
      datasourceId: string,
      query?: {
        /** When true the response returns immediately with a RUNNING attempt. Poll GET /analysis/:datasourceId/attempts/:attemptId for progress. */
        async?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AnalyzeAttemptDto, any>({
        path: `/analysis/${datasourceId}/attempts`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analysis
     * @name ListAnalyzeAttempts
     * @summary List analysis attempts for a data source
     * @request GET:/analysis/{datasourceId}/attempts
     * @response `200` `(AnalyzeAttemptDto)[]` List of analysis attempts
     */
    listAnalyzeAttempts: (datasourceId: string, params: RequestParams = {}) =>
      this.request<AnalyzeAttemptDto[], any>({
        path: `/analysis/${datasourceId}/attempts`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analysis
     * @name DeleteAnalyzeAttempt
     * @summary Delete an analysis attempt
     * @request DELETE:/analysis/{datasourceId}/attempts/{attemptId}
     * @response `200` `void` The deleted analysis attempt
     */
    deleteAnalyzeAttempt: (
      datasourceId: string,
      attemptId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/analysis/${datasourceId}/attempts/${attemptId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analysis
     * @name GetAnalyzeAttempt
     * @summary Get a specific analysis attempt by id. Use for polling progress while an async attempt is RUNNING.
     * @request GET:/analysis/{datasourceId}/attempts/{attemptId}
     * @response `200` `AnalyzeAttemptDto` The analysis attempt
     */
    getAnalyzeAttempt: (
      datasourceId: string,
      attemptId: string,
      params: RequestParams = {},
    ) =>
      this.request<AnalyzeAttemptDto, any>({
        path: `/analysis/${datasourceId}/attempts/${attemptId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analysis
     * @name GetLatestAnalyzeAttempt
     * @summary Get the latest analysis attempt
     * @request GET:/analysis/{datasourceId}/attempts/latest
     * @response `200` `AnalyzeAttemptDto` The latest analysis attempt
     */
    getLatestAnalyzeAttempt: (
      datasourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<AnalyzeAttemptDto, any>({
        path: `/analysis/${datasourceId}/attempts/latest`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  data = {
    /**
     * No description
     *
     * @tags Data
     * @name AggregateSeries
     * @summary Aggregate a collection into chart points with SQL GROUP BY
     * @request GET:/data/aggregate/{datasourceId}/{collection}
     * @response `200` `AggregateSeriesDto` Chart points covering the whole collection, not a page
     */
    aggregateSeries: (
      datasourceId: string,
      collection: string,
      query: {
        /** Column to group by (the chart x axis) */
        groupBy: string;
        /** Numeric column to SUM. Omitted means COUNT(*). */
        measure?: string;
        /** Bucket the group-by column. "month" date_truncs, for LINE charts. */
        bucket?: "none" | "month";
        /** Same JSON filter string the collection list uses. */
        filterGroups?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AggregateSeriesDto, any>({
        path: `/data/aggregate/${datasourceId}/${collection}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name ListData
     * @summary List data from a database
     * @request GET:/data/{datasourceId}/{collection}
     * @response `200` `DataListDto` The list of data
     */
    listData: (
      datasourceId: string,
      collection: string,
      query?: {
        /**
         * Filter criteria string
         * @example "name==John Doe,age>30,tags.contains(important)"
         */
        filters?: string;
        /**
         * Sort criteria string
         * @example "name:asc,age:desc"
         */
        sort?: string;
        /**
         * Page number for pagination
         * @default 1
         */
        page?: number;
        /**
         * Number of items per page
         * @default 10
         */
        limit?: number;
        /**
         * Comma-separated list of relations to expand (e.g., "partner,category")
         * @example "partner,category"
         */
        expand?: string;
        /**
         * JSON string representing filter groups with AND/OR logic
         * @example "{"operator":"AND","groups":[{"operator":"OR","filters":[{"field":"name","operator":"==","value":"John"},{"field":"name","operator":"==","value":"Jane"}]}]}"
         */
        filterGroups?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DataListDto, any>({
        path: `/data/${datasourceId}/${collection}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name CreateData
     * @summary Create data in a database
     * @request POST:/data/{datasourceId}/{collection}
     * @response `201` `void` The created data
     */
    createData: (
      datasourceId: string,
      collection: string,
      data: Object,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/data/${datasourceId}/${collection}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name GetData
     * @summary Get specific data from a database
     * @request GET:/data/{datasourceId}/{collection}/{id}
     * @response `200` `void` The requested data
     */
    getData: (
      datasourceId: string,
      collection: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/data/${datasourceId}/${collection}/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name UpdateData
     * @summary Update data in a database
     * @request PUT:/data/{datasourceId}/{collection}/{id}
     * @response `200` `void` The updated data
     */
    updateData: (
      datasourceId: string,
      collection: string,
      id: string,
      data: Object,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/data/${datasourceId}/${collection}/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name DeleteData
     * @summary Delete data from a database
     * @request DELETE:/data/{datasourceId}/{collection}/{id}
     * @response `200` `void` The deleted data
     */
    deleteData: (
      datasourceId: string,
      collection: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/data/${datasourceId}/${collection}/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  ui = {
    /**
     * No description
     *
     * @tags UI
     * @name GenerateUi
     * @summary Generate UI based on an analyze attempt
     * @request POST:/ui/generate
     * @response `201` `UiGenerationAttemptDto` The UI generation attempt
     */
    generateUi: (
      data: {
        analyzeAttemptId?: string;
        prompt: string;
        /** @default false */
        async?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UiGenerationAttemptDto, any>({
        path: `/ui/generate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UI
     * @name GetGeneratedUIs
     * @summary Get all generated UIs
     * @request GET:/ui/generated
     * @response `200` `(UiGenerationAttemptDto)[]` List of generated UI generation attempts
     */
    getGeneratedUIs: (params: RequestParams = {}) =>
      this.request<UiGenerationAttemptDto[], any>({
        path: `/ui/generated`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UI
     * @name GetLatestGeneratedUi
     * @summary Get the latest generated UI
     * @request GET:/ui/latest
     * @response `200` `UiGenerationAttemptDto` The latest generated UI generation attempt
     */
    getLatestGeneratedUi: (params: RequestParams = {}) =>
      this.request<UiGenerationAttemptDto, any>({
        path: `/ui/latest`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerCreateGuest
     * @summary Create a guest account
     * @request POST:/auth/guest
     * @response `201` `AuthTokenDto` Guest account created successfully
     */
    authControllerCreateGuest: (
      data: AuthGuestDto,
      params: RequestParams = {},
    ) =>
      this.request<AuthTokenDto, any>({
        path: `/auth/guest`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerRegister
     * @summary Register a new user
     * @request POST:/auth/register
     * @response `201` `void` User registered successfully
     */
    authControllerRegister: (data: RegisterDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/auth/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerLogin
     * @summary Login user
     * @request POST:/auth/login
     * @response `200` `AuthTokenDto` Login successful
     * @response `401` `void` Invalid credentials
     */
    authControllerLogin: (data: LoginDto, params: RequestParams = {}) =>
      this.request<AuthTokenDto, void>({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerVerifyEmail
     * @summary Verify email address
     * @request POST:/auth/verify/{code}
     * @response `200` `AuthTokenDto` Email verified successfully
     * @response `401` `void` Invalid or expired code
     */
    authControllerVerifyEmail: (code: string, params: RequestParams = {}) =>
      this.request<AuthTokenDto, void>({
        path: `/auth/verify/${code}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerSendVerificationEmail
     * @summary Send verification email
     * @request POST:/auth/resend-verification-email
     * @response `200` `void` Verification email sent
     */
    authControllerSendVerificationEmail: (
      data: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/resend-verification-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerRequestPasswordReset
     * @summary Request password reset
     * @request POST:/auth/password-reset/request
     * @response `200` `AuthCodeDto` Password reset code sent
     */
    authControllerRequestPasswordReset: (
      data: RequestPasswordResetDto,
      params: RequestParams = {},
    ) =>
      this.request<AuthCodeDto, any>({
        path: `/auth/password-reset/request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerResetPassword
     * @summary Reset password using code
     * @request POST:/auth/password-reset/reset
     * @response `200` `AuthUserDto` Password reset successful
     * @response `401` `void` Invalid or expired code
     */
    authControllerResetPassword: (
      data: ResetPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<AuthUserDto, void>({
        path: `/auth/password-reset/reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
